import { useQuery } from '@apollo/client';
import { useEffect, useMemo } from 'react';
import updateSubscribedList from '../utils/graphql/updateSubscribedList';
import populateObjects from '../utils/populateObjects';
import { useAllTopicMap } from './useAllTopics';
import { gql } from '../graphql/generated/gql';

export const FAVORITE_TOPIC_QUERY = gql(`
  query useFavoriteTopics {
    currentSession {
      user {
        id
        favoriteTopics {
          id
        }
      }
    }
  }
`);

const TOPIC_FAVORITE_ADDED_SUBSCRIPTION = gql(`
  subscription topicFavoriteAdded {
    topic: topicFavoriteAdded {
      id
    }
  }
`);

const TOPIC_FAVORITE_REMOVED_SUBSCRIPTION = gql(`
  subscription topicFavoriteRemoved {
    topic: topicFavoriteRemoved {
      id
    }
  }
`);

export default function useFavoriteTopics() {
  const { data, subscribeToMore } = useQuery(FAVORITE_TOPIC_QUERY, {
    fetchPolicy: 'network-only',
  });
  const topicMap = useAllTopicMap();

  useEffect(() => {
    const unsubscribes = [
      TOPIC_FAVORITE_ADDED_SUBSCRIPTION,
      TOPIC_FAVORITE_REMOVED_SUBSCRIPTION,
    ].map((query) =>
      subscribeToMore({
        document: query,
        updateQuery: updateSubscribedList(
          'currentSession.user.favoriteTopics',
          'topic',
          query === TOPIC_FAVORITE_ADDED_SUBSCRIPTION,
        ),
      }),
    );

    return () => {
      unsubscribes.forEach((unsubscribe) => {
        unsubscribe();
      });
    };
  }, [subscribeToMore]);

  return useMemo(() => {
    const favoriteTopics = data?.currentSession?.user?.favoriteTopics || [];
    return populateObjects(topicMap, favoriteTopics);
  }, [data?.currentSession?.user?.favoriteTopics, topicMap]);
}
